import { useState, useEffect, useRef } from 'react';

export const useElementWidth = <T extends HTMLElement>(defaultWidth = 0) => {
  const elementRef = useRef<T | null>(null);
  const [elementWidth, setElementWidth] = useState(defaultWidth);

  useEffect(() => {
    if (elementRef.current) {
      setElementWidth(elementRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (elementRef.current) {
        setElementWidth(elementRef.current.offsetWidth);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { elementRef, elementWidth };
};
